export enum SalaryApprovalStatus {
  Pending = 'pending',
}

export const ADD_SALARY_JOB_TYPE_KEY = 'addSalaryJobType'
export const FULL_TIME_OR_PART_TIME_JOB_TYPE = 'fullOrPartTime'
export const LOCUM_TENENS_OR_PRN_JOB_TYPE = 'locumTenensOrPrn'
export const SALARY_SUBMISSION_SURVEY_NAME = 'salary'
export const SALARY_SUBMISSION_SURVEY_ID_KEY = 'salarySubmissionId'
export const SALARY_ID_KEY = 'salaryId'
